/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Flex, Spacer, Text } from "@nordcloud/gnui";
import styles from "~/assets/styles/Runbook.module.css";
import { FlexContainer } from "~/components";
import { DetailsTitle } from "~/components/Styled/Common";
import { Divider } from "~/components/Styled/Divider";
import { Application } from "~/models";

type ApplicationDetailsInfoProps = {
  application: Application;
};

function ApplicationDetails({ application }: ApplicationDetailsInfoProps) {
  return (
    <Divider>
      <Spacer height="1rem" />
      <Text isTitle weight="medium">
        Application Details
      </Text>
      <FlexContainer direction="column" align="flex-start">
        <Flex>
          <DetailsTitle className={styles.propertyLabel}>
            Application Name
          </DetailsTitle>
          <Text tag="span" className={styles.propertyValue}>
            {application?.name}
          </Text>
        </Flex>

        <Spacer height="0.2rem" />
        <Flex>
          <DetailsTitle className={styles.propertyLabel}>
            Application Owner
          </DetailsTitle>
          <Text tag="span" className={styles.propertyValue}>
            {application?.owner?.firstName?.length > 0
              ? application?.owner?.firstName.concat(
                  " ",
                  application?.owner?.lastName
                )
              : "-"}
          </Text>
        </Flex>

        <Spacer height="0.2rem" />
      </FlexContainer>

      <Spacer height="1rem" />
    </Divider>
  );
}

export { ApplicationDetails };
